<div class="ancillary-bundle-item" [class.selected]="isSelected">
  <div>
    <div class="d-flex justify-content-center ancillary-bundle-item-img">
      <img
        height="88"
        [width]="isBundle ? 142 : 88"
        src="assets/images/{{ img }}.webp"
        alt="ancillary-bundle-item-img"
      />
    </div>
  </div>

  <div class="ancillary-bundle-item-text">
    <div>
      <p class="bold">{{ isChange ? 'No, remove my protection' : title }}</p>

      @if (isBundle) {
        <div class="d-flex pt-1 g-1 align-items-center">
          <img height="16" width="16" src="assets/icons/travelers_fav.svg" alt="travelers_fav" />
          <p class="caption semi-bold text-lightblue-600">Travelers' favorite</p>
        </div>
      }
    </div>

    <div class="d-flex g-2 align-items-center">
      <div>
        @if (ancillary.priceWithoutDiscountPerTraveler) {
          <div class="d-flex align-items-center g-1">
            <h3 class="bold text-green-800">
              {{ prefix }}{{ ancillary.pricePerTraveler | portalCurrency }}
            </h3>
            @if (!prefix) {
              <p class="text-through">
                {{ ancillary.priceWithoutDiscountPerTraveler | portalCurrency }}
              </p>
            }
          </div>
        } @else {
          <p class="bold">{{ prefix }}{{ ancillary.pricePerTraveler | portalCurrency }}</p>
        }
        <p>per traveler</p>
      </div>

      @if (discountSize && isBundle && !prefix) {
        <div class="ancillary-bundle-item-chip">
          <p class="caption semi-bold">-{{ discountSize }}%</p>
        </div>
      }
    </div>
  </div>
</div>
